<template>
  <div>
    <v-card flat>
      <v-card-text>
       
        <user-profile :patientinfo="patientinfo" :data="data" :useData="useData" />

        <v-row style="margin-top: 1rem;">
          <v-col cols="12" class="box" style="margin-top: 1rem;">

            <ValidationObserver ref="observer" tag="form">
              <v-form v-model="valid" class="position-relative">
                <block v-if="loading"></block>

                <v-row class="ml-2 mr-2" style="margin-top: .3rem;">
                  <v-col cols="12" class="tabsNh">

                    <v-col v-if="selectedvalues" cols="12" md="12" style="display: flex; justify-content: space-between;">

                      <div style="width: 212px;" ></div>
                      <div>
                          <v-btn v-if="$store.getters['rolesUser/getCustomRole'](107)" small class="btn-save mr-1" @click.prevent="showBillPatient = true">
                              <v-icon class="mr-3">mdi-account-details</v-icon> Facturar paciente
                          </v-btn>
                      </div>
                      <div>
                        <v-btn class="mr-1" small
                          v-if="$store.getters['rolesUser/getCustomRole'](136)"
                          @click="print = { show: true, data: { groming: grooming, patientinfo: patientinfo, useData: useData, customer: patientinfo.customer } }">
                          <v-icon> mdi-printer </v-icon>

                        </v-btn>
                        <v-btn  v-if="$store.getters['rolesUser/getCustomRole'](133)" small class="btnblue mr-1" @click="showhistory = !showhistory">
                          <v-icon>
                            mdi-magnify
                          </v-icon>
                        </v-btn>
                        <v-btn small class="btnclean" @click.prevent="resetGrooming">
                          <v-icon>
                            mdi-broom
                          </v-icon>

                        </v-btn>
                      
                        <v-btn small v-if="selectedvalues && (
                          $store.getters['rolesUser/getCustomRole'](134)
                        )" class="btn-save" @click.prevent.stop="addGrooming">
                          <v-icon>mdi-content-save</v-icon>
                        </v-btn>
                      </div>
                    </v-col>
                    <v-col cols="12" md="12" v-if="grooming.id_vpg"
                      style="display: flex; justify-content: space-between; ">
                      <div style="width: 212px;">
                        <v-btn v-if="$store.getters['rolesUser/getCustomRole'](135)
                          " small color="error" @click.prevent="confirmDelete(todelete)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                      <div>
                          <v-btn v-if="$store.getters['rolesUser/getCustomRole'](107)" small class="btn-save mr-1" @click.prevent="showBillPatient = true">
                              <v-icon class="mr-3">mdi-account-details</v-icon> Facturar paciente
                          </v-btn>
                      </div>
                      <div>
                        <v-btn small class="mr-1"
                          v-if="$store.getters['rolesUser/getCustomRole'](136)"
                          @click="print = { show: true, data: { groming: grooming, patientinfo: patientinfo, useData: useData, customer: patientinfo.customer } }">
                          <v-icon> mdi-printer </v-icon>
                        </v-btn>
                        <v-btn small 
                          v-if="$store.getters['rolesUser/getCustomRole'](133)"
                          class="btnblue mr-1" @click="showhistory = !showhistory">
                          <v-icon>
                            mdi-magnify
                          </v-icon>
                        </v-btn>
                        <v-btn small class="btnclean" @click.prevent="resetGrooming">
                          <v-icon>
                            mdi-broom
                          </v-icon>
                        </v-btn>
                        <v-btn small class="btn-save" @click.prevent="updateGrooming" v-if="grooming.id_vpg &&
                          $store.getters['rolesUser/getCustomRole'](134)"
                          >
                          <v-icon>mdi-content-save</v-icon>
                        </v-btn>

                      </div>
                    </v-col>



                  </v-col>
                  <v-col cols="12" md="3" sm="12" style="margin-top: 1rem;">
                    <div style="width: 285px !important; display: flex;">

                      <date-picker label="Fecha" @dateSelected="(param) => {

                        grooming.date = param
                        checktodaygroming(param)
                      }" v-model="grooming.date"></date-picker>

                    </div>
                  </v-col>
                  <v-col cols="12" md="8" sm="12">

                  </v-col>

                  <v-col cols="12" md="1" sm="6" style="display: flex; justify-content: flex-end; margin-top: 1rem;">
                    <v-btn :class="showBgcolorNotes" @click.prevent="showNotes = !showNotes">
                      Comentarios

                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="3">

                    <v-select outlined dense :items="services" :error-messages="errors" v-model="grooming.typeofservice"
                      label="Tipo de servicio" item-text="label" item-value="value" attach>
                    </v-select>

                  </v-col>
                  <v-col cols="12" md="3">

                    <v-select outlined dense attach :items="sizes" :error-messages="errors" v-model="grooming.size"
                      label="Selecciona tamaño" item-text="label" item-value="value">
                    </v-select>

                  </v-col>
                  <v-col cols="12" md="3">

                    <v-text-field outlined dense :error-messages="errors" v-model="grooming.groomer" label="Peluquero"
                      placeholder="Escribe el nombre del peluquero">
                    </v-text-field>

                  </v-col>
                  <v-col cols="12" md="3">

                    <v-text-field outlined dense :error-messages="errors" v-model="grooming.visit" label="Visita"
                      placeholder="Escribe sobre la visita">
                    </v-text-field>

                  </v-col>
                  <v-col cols="12" md="2">
                    <date-picker label="Siguiente cita" @dateSelected="(param) => (grooming.nextappointment = param)"
                      v-model="grooming.nextappointment"></date-picker>
                  </v-col>
                  <v-col cols="12" md="12">

                    <!-- <quill-editor v-model="grooming.comments" :options="quillOptions"  v-show="showNotes"  @change="onEditorChange($event)"></quill-editor> -->
                  </v-col>
                  <v-col cols="12" md="12"
                    style="display: flex; justify-content: flex-end;margin-top: 1.5rem; margin-bottom: 1rem;"></v-col>

                  <!--  <v-col v-if="selectedvalues"  cols="12" md="12" style="display: flex; justify-content: flex-end;margin-top: 1.5rem; margin-bottom: 1rem;" >
                      <v-btn v-if="selectedvalues" class="btn-save" @click.prevent.stop="addGrooming">
                          Agregar registro
                        </v-btn>
                    </v-col>
                    <v-col cols="12" md="12"  v-if="grooming.id_vpg" style="display: flex; justify-content: space-between; margin-top: 1.5rem; margin-bottom: 1rem;">
                      <v-btn class="btndelete"  @click.prevent="confirmDelete(todelete)">
                        Eliminar registro
                      </v-btn>
                      <v-btn class="btn-save" @click.prevent="updateGrooming" v-if="grooming.id_vpg">
                          Guardar registro
                        </v-btn>
                     </v-col>
                   -->
                </v-row>

              </v-form>
            </ValidationObserver>

          </v-col>
        </v-row>
        <br />
        <v-row style="margin-top: 1rem;">
          <v-col cols="12" class="box" style="margin-top: 1rem;">
            <v-col cols="12" class="d-flex justify-space-between align-center">
              <h3>Galería del paciente</h3>
              <v-btn class="btn-save" @click.prevent.stop="addImagesDialog = !addImagesDialog">
                Agregar a galería
              </v-btn>
            </v-col>
            <v-col cols="12" class="galleryView">
              <div v-for="value in imagesToShow" :key="value.ID_Image" class="galleryItemWrapper">
                <img :src="value.Path" @click="
                  (imageUrl = value.Path),
                  (ZoomDialog = !ZoomDialog)
                  " class="galleryItem">
                  <v-icon color="error" class="deleteGalleryItem" 
                    @click.prevent="showAlert('question', 'Confirmar', 'Esta seguro de eliminar este registro', 'confirmDeleteGalleryItem');
                    dataTodelete = value.ID_Image
                  ">mdi-delete</v-icon>
              </div>
            </v-col>
          </v-col>
        </v-row>

        <v-dialog v-model="showNotes" max-width="60%">
          <v-card style="padding: 14px;">
            <div style="margin-top: .3rem;margin-bottom: .3rem; display: flex;justify-content: flex-end;">
              <v-btn small class="btndelete" @click.prevent="showNotes = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <quill-editor v-model="grooming.comments" :options="quillOptions"
              @change="onEditorChange($event)"></quill-editor>
          </v-card>

        </v-dialog>

        <!-- Dialog bill patient -->
    <VeterinaryBillingPanel v-model="showBillPatient" :customer-id="data && data.ID_Customer ? data.ID_Customer : (customer && customer.ID_Customer ? customer.ID_Customer : null)" />
        <!-- Dialog bill patient -->

        <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
        </alerts>


        <!--  <v-dialog v-model="dialog" max-width="350">
        <v-card>
          <v-card-title class="text-h6">
            ¿Desea eliminar el registro?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialog = false">
              No
            </v-btn>
            <v-btn color="green darken-1" text @click="deleteGrooming(temp); dialog = false; temp = null">
              Si
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>   -->
        <Grommings :data="print"></Grommings>
      </v-card-text>

      <v-dialog v-model="showhistory" :width="'90%'" scrollable>
        <v-card class="pa-4">
          <v-card-text>
            <div style="margin-top: .3rem;margin-bottom: .3rem; display: flex;justify-content: flex-end;">
              <v-btn small class="btndelete" @click.prevent="showhistory = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>

            <GeneralFilter entity="peluquería" :filterEndpoint="$API.veterinarypatientgrooming.filterGroomingToPatient"
              :search="search" @emptyFilter="getAllPatientGrooming" @filtered="filterHandler">
              <DxDataGrid class="isScrolledByGeneralFilter" :show-borders="true" :data-source="groomings" key-expr="ID_VPG" @exporting="onExporting" :column-auto-width="true"
              style="width: fit-content;">
                <DxExport :enabled="true" />
                <DxColumn :width="80" cell-template="show-template" caption=""></DxColumn>
                <DxPaging :page-size="10" />
                <!-- <DxColumn data-field="ID_VPG" caption="Id"></DxColumn> -->
                <DxColumn data-field="Date" caption="Fecha" :min-width="100"></DxColumn>
                <DxColumn data-field="NextAppointment" caption="Proxima cita" :min-width="100"></DxColumn>
                <DxColumn data-field="TypeOfService" caption="Tipo de servicio" :min-width="200"></DxColumn>
                <DxColumn data-field="Groomer" caption="Peluquero" :min-width="200"></DxColumn>
                <DxColumn v-if="$store.getters['rolesUser/getCustomRole'](135)" :width="80" cell-template="show-delete" caption=""></DxColumn>
                <template #show-delete="{ data }">
                  <div>

                    <a href="" class="mx-2" @click.prevent.stop="confirmDelete(data.data); showhistory = false">
                      <v-icon color="error">mdi-delete</v-icon>
                    </a>
                  </div>
                </template>
                <template #show-template="{ data }">
                  <div>
                    <a href="#"
                      @click.prevent.stop="selectedGrooming(data.data); selectedvalues = false; showhistory = false">
                      <v-icon color="primary">mdi-eye</v-icon>
                    </a>
                  </div>
                </template>
              </DxDataGrid>
            </GeneralFilter>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>

    <v-dialog v-model="addImagesDialog" scrollable max-width="80%">
      <AddImages @uploadedImage="uploadedImageData($event)" :visible="addImagesDialog" @closepopup="addImagesDialog = false"
        :type="form.TypeOfImage || ''" TypeOfImage="Peluquería" files-to-accept=".jpeg,.jpg,.png,.gif" selector-disabled></AddImages>
    </v-dialog>

    <v-dialog v-model="ZoomDialog" v-if="imageUrl" scrollable max-width="90%">
      <v-card>
        <v-card-title>
          <span>Previsualización</span>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="ZoomDialog = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          {{ form.TypeOfImage }}
          <ZoomImage :ZoomDialog="ZoomDialog" :imageUrl="imageUrl" :type="form.TypeOfImage || ''"></ZoomImage>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

//import { jsPDF} from "jspdf"
//import html2canvas from 'html2canvas'
import Vue from "vue"
import Block from "@/components/Block"
import { DxDataGrid, DxColumn, DxPaging, DxExport } from "devextreme-vue/data-grid"
import alerts from "@/components/Alerts"
import { printToExcel } from "@/helpers/printToexcel"
import DatePicker from "../../../components/DatePicker"
import Grommings from "../../../components/ReportsAndPrintings/Grommings.vue"
import { quillConfig } from "../../../helpers/quillconfig"
import { mapState } from 'vuex'
import GeneralFilter from '@/components/GeneralFilter.vue'
//import Block from "@/components/Block";
import UserProfile from "@/components/Displays/UserProfileDisplay.vue";
import { numberWithCommas } from "@/helpers/money";
import VeterinaryBillingPanel from "@/components/veterinary/VeterinaryBillingPanel.vue";
import AddImages from "../../../components/VeterinaryImage/addImages.vue"
import ZoomImage from "../../../components/VeterinaryImage/zoomImageView.vue"

export default {
  name: "VeterinaryGrooming",
  components: { DxDataGrid, DxColumn, DxPaging, DatePicker, Block, alerts, Grommings, AddImages, DxExport, GeneralFilter,UserProfile, ZoomImage, VeterinaryBillingPanel },
  props: ["data", "win"],
  data: () => ({
    print: {
      show: false,
      data: []
    },
    alert: {
      type: "success",
      show: false,
      header: "",
      body: "",
    },
    currency: JSON.parse(localStorage.getItem('branch')).Currency,
    itemQtyPattern: /^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/i,
    showBillPatient: false,
    useData: {},
    form: {},
    showServicesToAdd: false,
    showProductsToAdd: false,
    addImagesDialog: false,
    ZoomDialog: false,
    imageUrl: null,
    images: [],
    imagesToShow: [],
    servicesToBill: [],
    productsToBill: [],
    servicesToAdd: [],
    productsToAdd: [],
    filterProducts: {
        filter: null
    },
    searchToBill: {
        filter: null
    },
    togglehide1: true,
    togglehide2: true,
    togglehide3: true,
    warehouses: [],
    selectedWarehouse: null,
    customer: {},
    showBgcolorNotes: "tabs",
    quillOptions: quillConfig,
    showNotes: false,
    groomingtodelete: null,
    valid: false,
    url: null,
    services: [
      { label: 'Baño', value: "Baño" },
      { label: 'Baño Medicado', value: "Baño Medicado" },
      { label: 'Corte', value: "Corte" },
      { label: 'Corte de uñas', value: "Corte de uñas" },
      { label: 'Corte y Baño', value: "Corte y Baño" },
      { label: 'Corte y Baño Medicado', value: "Corte y Baño Medicado" },
      { label: 'Vaciamiento de glándulas adanales', value: "Vaciamiento de glándulas adanales" },
      { label: 'Recorte de pelo de orejas', value: "Recorte de pelo de orejas" },
      { label: 'Lavado de dientes', value: "Lavado de dientes" },
    ],
    sizes: [
      { label: 'Grande', value: "Grande" },
      { label: 'Mediano', value: "Mediano" },
      { label: 'Pequeño', value: "Pequeño" },
    ],
    patientinfo: [],
    groomings: {},
    grooming: {},
    loading: false,
    id_user_login: null,
    dialog: false,
    temp: null,
    selectedvalues: true,
    showGroming: false,
    todelete: null,
    showhistory: false,
    //useData: null,
    ID_Branch: JSON.parse(localStorage.getItem('branch')).ID_Branch,
    search: {}
  }),
  computed: {
    ...mapState(
      "rolesUser",
      {
        rolesStatus: (state) => state.roles,
      })
  }
  ,
  async mounted() {
    this.$store.dispatch('rolesUser/getAllRoles')
    if (this.data) {
      Object.keys(this.data).map((el) => {
        Vue.set(this.patientinfo, el.toLowerCase(), this.data[el])
      })
      this.url =
        this.$store.getters.getBackendUrl +
        "/public" +
        this.data.ProfilePicPath
      this.getAllPatientGrooming()
    }
    Vue.set(this.grooming, "id_patient", this.patientinfo.id_patient)
    this.useData = JSON.parse(localStorage.getItem("user"))
    this.id_user_login = JSON.parse(localStorage.getItem("user")).id
    this.search.patientID = this.patientinfo.id_patient
    //this.useData = JSON.parse(localStorage.getItem("user"));
    this.customer.ID_Customer = this.data.ID_Customer;
    // console.log('customer', this.customer);
    this.warehouses = await this.$API.warehouse.getWarehousesFiltered({ isPatient: true });
    this.filterProducts.business = this.useData.businessid;
    this.filterProducts.branch = this.useData.branch;
    const found = this.warehouses.find((wh) => wh.Active == true && wh.ID_Branch == this.ID_Branch); 
    this.selectedWarehouse = found ? found.ID_Warehouse : (this.warehouses.length == 0 ? 0 : this.warehouses[0].ID_Warehouse);
    //this.selectedWarehouse = this.warehouses.length == 0 ? 0 : this.warehouses[0].ID_Warehouse;
    this.filterProducts.warehouse = this.selectedWarehouse;
    this.getImages();
    await this.getServices();
    await this.getProducts();
    await this.getDefaultServices();
  },
  watch: {
    servicesToAdd: {
        deep: true,
        immediate: true,
        handler(newVal) {
          this.showServicesToAdd = newVal.length !== 0;
          newVal.forEach(service => {
            if (service.Price !== undefined) {
              service.UnitPrice = service.Price;
            }
          });
        }
    },
    productsToAdd: {
        deep: true,
        immediate: true,
        handler() {
            if(this.productsToAdd.length !== 0) {
                this.showProductsToAdd = true;
            }
            else {
                this.showProductsToAdd = false;
            }
        }
    },
  },
  methods: {
    totalXQuantity( { Price, quantity } ) {
        return `${this.currency}${ numberWithCommas( parseFloat( Price * quantity ).toFixed( 2 ) ) }`
    },
    async handleSelectWarehouse() {
        this.loading = true;
        this.filterProducts.warehouse = this.selectedWarehouse;
        await this.getProducts();
        this.$refs.werehouseRef.blur();
        this.loading = false;
    },
    addService(data) {
        const isRepetitive = this.servicesToAdd.find((service) => service.ID_Service === data.ID_Service);

        if (!isRepetitive) {
            this.servicesToAdd.push({ ...data, quantity: 1, UnitPrice: parseFloat(data.Price), unitPrice: `${this.currency}${numberWithCommas(parseFloat(data.Price).toFixed(4))}` });
        } else {
            const service = this.servicesToAdd.find(item => item.ID_Service === data.ID_Service)
            if(service) {
                service.quantity++;
            }
            // console.log("Service already exists in servicesToAdd");
        }
    },
    addProduct(data) {
        const isRepetitive = this.productsToAdd.find((item) => item.ID_Item === data.ID_Item);
        if (!isRepetitive) {
            this.productsToAdd.push({ ...data, quantity: 1, UnitPrice: parseFloat(data.ItemPrice), unitPrice: `${this.currency}${numberWithCommas(parseFloat(data.ItemPrice).toFixed(4))}` });
        } else {
            const product = this.productsToAdd.find((item) => item.ID_Item === data.ID_Item);
            if(product) {
                product.quantity++;
            }
            // console.log("Product already exists in productsToAdd.");
        }
    },
    deleteService(data) {
        const serviceIndex = this.servicesToAdd.findIndex((service) => service.CodeService === data.CodeService);

        if (serviceIndex !== -1) {
            this.servicesToAdd.splice(serviceIndex, 1);
        }
    },
    deleteProduct(data) {
        const index = this.productsToAdd.findIndex((item) => item.ID_Item === data.ID_Item);

        if (index !== -1) {
            this.productsToAdd.splice(index, 1);
        }
    },
    getServices() {
        this.$API.services.getAllServices(this.filterServices).then((response) => {
            this.servicesToBill = response;
        });
    },
    getProducts() {
        this.$API.products.getProductsToBillForInvoice(this.filterProducts).then((response) => {
            this.productsToBill = response;
        });
    },
    getDefaultServices() {
        this.$API.services.getDefaultServices().then((response) => {
            this.servicesDefault = response;
        });
    },
    servicesFilterHandler(response) {
        this.servicesToBill = response;
    },
    productsFilterHandler(response) {
        this.productsToBill = response;
    },
    getItemsToBeBilled() {
        this.$API.veterinarypatients.getServicesToBeBilled({ 'customer': this.data.ID_Customer })
        .then((response) => {
            this.servicesToAdd = []
            for(let i = 0; i < response.length; i++){
            this.servicesToAdd.push({ ...response[i], unitPrice: `${this.currency}${numberWithCommas(parseFloat(response[i].Price).toFixed(4))}` });
            }
        });
        this.$API.veterinarypatients.getProductsToBeBilled({ 'customer': this.data.ID_Customer }).then((res) => {
            if(res.success) {
            this.productsToAdd = [];
            for (const item of res.data) {
                this.productsToAdd.push({ ...item, quantity: item.Quantity, unitPrice: `${this.currency}${numberWithCommas(parseFloat(item.ItemPrice).toFixed(4))}`});
            }
            }
        });
    },
    async saveItemsToBeBilled() {
        this.showBillPatient = false;
        this.loading = true;

        if (this.groomings.length > 0) {
          for (const i in this.groomings) {
            if (this.groomings[i].Date == this.date) {
              this.showAlert(
                "danger",
                "error",
                "Ya existe un registro para la fecha seleccionada"
              );

              return
            }
          }
        }

        try {
            if(this.servicesToAdd.length) {
            await this.$API.veterinarypatients.saveServicesToBeBilled({ 'customer': this.customer.ID_Customer, 'services': this.servicesToAdd })
            .then((res) => {
                console.log(res);
            })
            .catch((err) => {
                console.log(err);
                throw new Error('Ocurrio un error al guardar los servicios.');
            });
            }
            if(this.productsToAdd.length) {
            // console.log(this.productsToAdd);
            
            await this.$API.veterinarypatients.saveProductsToBeBilled({ 'customer': this.customer.ID_Customer, 'products': this.productsToAdd })
            .then((res) => {
                console.log(res);
            })
            .catch((err) => {
                console.log(err);
                throw new Error('Ocurrio un error al guardar los productos.');
            });
            }
            await this.getItemsToBeBilled();
            this.loading = false;
            this.showAlert("success", "Exito", "Los datos de facturación de este paciente han sido guardados.")
        } catch (error) {
            console.log(error);
            this.loading = false;
            this.showAlert("warning", "Advertencia", "Ha ocurrido un error, por favor intentarlo nuevamente.")
        }

    },
    async billedPatientsOfCustomer() {
        this.showBillPatient = false;
        this.loading = true;

        try{
            await this.$API.veterinarypatients.saveServicesToBeBilled({'customer': this.customer.ID_Customer, 'services': this.servicesToAdd});
            await this.$API.veterinarypatients.saveProductsToBeBilled({ 'customer': this.customer.ID_Customer, 'products': this.productsToAdd });
            let responseBill = await this.$API.veterinarypatients.billedPatientsOfCustomer({ 'customer': this.customer.ID_Customer});

            this.loading = false;

            if (responseBill?.status == false) {
              this.showAlert("dangerHtml", "Advertencia", "No se puede crear el comprobante porque se encontraron los siguientes errores: <br/><br/>" + responseBill.message)  
              return
            }

            this.showAlert("success", "Exito", `Se ha realizado la factura de los ${this.servicesToAdd.length && this.productsToAdd.length ? 'servicios y productos' : this.servicesToAdd.length ? 'servicios' : this.productsToAdd.length ? 'productos' : 'items' } seleccionados, podrá observarla en el módulo de POS en listo para facturar.`);
            await this.getItemsToBeBilled();        
        }
        catch(error) {
            console.log(error)
            this.loading = false
            this.showAlert("warning", "Advertencia", "Ha ocurrido un error, por favor intentarlo nuevamente.")
        }
    },

    onExporting(e) {
      printToExcel(e, "Peluqueria")
    },
    checktodaygroming(date) {
      /*let datetoday = false
      this.groomings.forEach(el => {
        if (el.Date == date) {
          this.selectedGrooming(el)
          datetoday = true
        }
      })
      if (!datetoday) {
        this.resetGrooming()
        this.grooming.date = date
      }*/
      this.grooming.date = date

    },

    getAllPatientGrooming() {
      this.$API.veterinarypatientgrooming
        .getGroomingToPatientHistory(this.patientinfo.id_patient)
        .then((response) => {
          this.groomings = response
          let datetoday = this.moment().format("DD/MM/YYYY")
          this.groomings.forEach(element => {

            if (element.Date == datetoday) {
              this.selectedGrooming(element)
            }

          })
        })
    },

    selectedGrooming(data) {
      this.todelete = data
      Object.keys(data).map((el) => {
        Vue.set(this.grooming, el.toLowerCase(), data[el])
      })
      this.selectedvalues = false
    },

    Preview_image() {
      this.url = URL.createObjectURL(this.image)
    },

    onEditorChange(e) {
      this.grooming.comment = e.html
      if (this.grooming.comment != "") {
        this.showBgcolorNotes = 'tabsContent'
      }
      else if (this.grooming.comment == "" || this.grooming.comment == "<p><br></p>") {
        this.showBgcolorNotes = 'tabs'
      }
      else {
        this.showBgcolorNotes = 'tabs'
      }
    },

    async addGrooming() {
      this.$refs.observer.validate()
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.loading = true
        let datetoday = false
        this.groomings.forEach(element => {
          if (element.Date == this.grooming.date) {
            this.showAlert("danger", "error", "Ya existe un registro para la fecha seleccionada")

            datetoday = true
          }
        })
        if (!datetoday) {
          this.loading = false

          const formdata = new FormData()
          Vue.set(this.grooming, "id_user_insert", this.id_user_login)
          formdata.append("veterinarygrooming", JSON.stringify(this.grooming))


          this.$API.veterinarypatientgrooming
            .addGroomingToPatient(formdata)
            .then(() => {
              this.loading = false
              this.showAlert("success", "Exito", "Registro agregado correctamente")
              this.resetGrooming()
              //this.$store.dispatch('reloadData', 'veterinarypatients')
              this.getAllPatientGrooming()
            })
            .catch(() => {
              this.loading = false
              this.showAlert("danger", "error", "Error al agregar el registro")
            })
          return
        }
        else {
          this.loading = false
        }
      }
    },

    async updateGrooming() {
      this.$refs.observer.validate()
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.loading = true
        const formdata = new FormData()
        Vue.set(this.grooming, "id_user_update", this.id_user_login)
        formdata.append("veterinarygrooming", JSON.stringify(this.grooming))
        this.$API.veterinarypatientgrooming
          .updateGroomingToPatient(this.grooming.id_vpg, formdata)
          .then(() => {
            this.loading = false
            // this.$emit('reloadData');
            this.showAlert("success", "Exito", "Registro actualizado correctamente")
            this.resetGrooming()
            //this.$store.dispatch('reloadData', 'veterinarypatients')
            this.getAllPatientGrooming()
          })
          .catch(() => {
            this.loading = false
            this.showAlert("danger", "error", "Error al actualizar el registro")
          })
      }
    },

    deleteGrooming(data) {
      this.loading = true
      this.grooming.id_vpg = data.ID_VPG
      this.$API.veterinarypatientgrooming
        .deleteGroomingToPatient(this.grooming.id_vpg)
        .then(() => {
          this.loading = false
          this.showAlert("success", "Exito", "Registro eliminado correctamente")
          this.resetGrooming()
          this.getAllPatientGrooming()
          //this.$store.dispatch('deleteWindowByUuid', {uuid: this.win.uuid});
          //this.$store.dispatch('reloadData', 'veterinarypatients')
        })
        .catch(() => {
          this.loading = false
          this.showAlert("danger", "error", "Error al eliminar el registro")
        })
    },

    resetGrooming() {
      this.grooming.id_vpg = ''
      this.grooming = {}
      this.grooming.date = this.moment().format("DD/MM/YYYY")
      Vue.set(this.grooming, "id_patient", this.patientinfo.id_patient)
      this.$refs.observer.reset()
      this.selectedvalues = true
      this.todelete = null
    },
    closeAlert() {
      this.alert.show = false
      this.groomingtodelete = null

      if (this.alert.options == "confirmDeleteGalleryItem") {
        this.dataTodelete = null
      }
    },
    acceptAlert() {
      this.alert.show = false

      if (this.alert.options == "deletegrowing") {
        this.deleteGrooming(this.groomingtodelete)
      }
      if (this.alert.options == "confirmDeleteGalleryItem") {
        this.DeleteImageRow(this.dataTodelete);
      }
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type
      this.alert.type = type
      this.alert.header = header
      this.alert.body = body
      this.alert.show = true
      this.alert.options = options != null ? options : null
    },
    confirmDelete(data) {
      this.showAlert("question", "Confirmar", "¿Esta seguro que desea eliminar el registro seleccionado?", "deletegrowing")
      this.groomingtodelete = data
    },
    filterHandler(response){
      this.groomings = response
    },

    /*printGrooming(){
      const doc = new jsPDF();
      doc.html("<html><body><p>Hola</p></body></html>"
      , {
        callback: function (doc) {
          doc.save();
        }
      });
    }*/
    checkFileType(filename) {
      const validExtensions = ['xlsx', 'xls', 'pdf', 'doc', 'docx'];
      const fileExtension = filename.split('.').pop().toLowerCase();
      return validExtensions.includes(fileExtension);
    },
    uploadedImageData(e) {
      let newFile = {
        ...e,
        Picture: e.file.name,
      }
      this.images.push(newFile);
      // if (this.isEdit) this.tempFiles.push(newFile);
      this.loading = true;
      let arr = [];
      for (let x of this.images) {
        /*  console.log('XXTypeOfImage',x.TypeOfImage); */

        x.file['TypeOfImage'] = x.TypeOfImage
        arr.push(x.file);
      }

      this.form.files = arr;
      this.form.ID_Patient = this.patientinfo.id_patient;
      this.form.ID_User_Insert = this.id_user_login;
      this.form.ID_Business = JSON.parse(localStorage.getItem("user")).businessid;
      this.form.ID_Branch = JSON.parse(localStorage.getItem("user")).branch;
      this.form.TypeOfImage = this.TypeOfImage;
      const formData = new FormData();
      for (const i of Object.keys(arr)) {
        formData.append("file", arr[i]);
        /*    console.log("type of new register", arr[i].TypeOfImage); */
        formData.append('types', arr[i].TypeOfImage);

      }
      formData.append("form", JSON.stringify(this.form));

      setTimeout(() => {
        this.$API.veterinaryImages.createImagesData(formData).then(
          () => {
            this.showAlert("success", "Éxito", "Registro Agregado");
            this.getImages();
            this.images.length = 0;
            this.loading = false;
            this.addImagesDialog = false;
          },
          (err) => {
            // this.$toasted.info(err.message);
            console.log('error', err);
            this.loading = false;
            this.showAlert("danger", "Error", "No se guardó Registro");
          }
        );
      }, 1000);
    },
    getImages() {
      this.loading = true;
      this.imagesToShow.length = 0;
      this.$API.veterinaryImages.getImages(this.patientinfo.id_patient).then(
        async (res) => {
          this.loading = false;
          if (res.length > 0) {
            for (const element of res) {
              await this.filesByImageID(element.ID_Images)
            }
            this.imagesToShow.sort((a, b) => {
              return new Date(b.SystemDateInsert) - new Date(a.SystemDateInsert);
            });
          }
        },
        (err) => {
          console.log('error', err);
          this.loading = false;
          this.showAlert("danger", "Error", "Hubo un error al obtener los datos");
        }
      );
    },
    async filesByImageID(id) {
      this.loading = true;

      await this.$API.veterinaryImages.filesByImageID(id).then(
        (res) => {
          this.imagesToShow = [...this.imagesToShow, ...res.files];
          this.imagesToShow = this.imagesToShow.filter(ele => this.checkFileType(ele.Picture) === false && ele.TypeOfImage === 'Peluquería');
          this.loading = false;
        },
        (err) => {
          // this.$toasted.info(err.message);
          console.log('error', err);
          this.loading = false;
        }
      );
    },
    DeleteImageRow(id) {
      this.loading = true;
      this.$API.veterinaryImages.deletespecifiedFile(id).then(
        () => {
          this.showAlert("success", "Éxito", "Registro Eliminado");
          this.imagesToShow = this.imagesToShow.filter((item) => item.ID_Image != id);
          this.loading = false;
          this.dataTodelete = null
        },
        (err) => {
          this.showAlert("danger", "Error", "Ocurrió un error al eliminar el Registro");
          //  this.$toasted.info(err.message);
          console.log('error', err);
          this.loading = false;

        }
      );
    },
  },
}
</script>


<style scoped>
.btndisable {
    background-color: #41464c !important;
    color: white;
}
.btndisable2 {
    background-color: #1976d2 !important;
    color: white;
}

.box {
  border-style: solid;
  border-color: black;
  border-width: 1px;
  background-color: white;

  border-radius: 15px;


}

.tabsNh {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;

}

.infopatient {
  margin-top: 5%;
}

.tabs:hover {
  background-color: rgba(80, 80, 80, 1);
  cursor: pointer;
}

.tabsContent:hover {
  background-color: #FFB266;
  cursor: pointer;
}

.tabs {

  background-color: rgba(60, 60, 60, 1) !important;
  color: white !important;


}

.tabsContent {

  background-color: #F29D35 !important;
  color: white !important;



}

.btn-add {
  background-color: #3498DB !important;
  color: white;
}

.btnsave {
  background-color: #00A178 !important;
  color: white;
  margin-left: .3rem;
  margin-right: .3rem;
}

.btnblue {
  background-color: #1976d2 !important;
  color: white;
}


.tabsB {
  width: 100%;
  padding: 10px;
  background-color: #1976d2;
  color: white;
  border-radius: 15px;
  border-style: solid;
  border-color: black;
  border-width: 1px;
}

.tabsB:hover {

  cursor: pointer;
}

.btnclean {
  background-color: #F29D35 !important;
  color: white;


}

.btndelete {
  background-color: #E3191E !important;
  color: white;
}

.galleryView {
  display: grid;
  /* Crea columnas de al menos 250px, llenando el espacio disponible */
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px; /* Espacio entre imágenes */
  padding: 15px;
}

.galleryItemWrapper {
  position: relative;
}

.galleryItem {
  width: 100%;
  height: 200px; /* Altura fija para uniformidad */
  object-fit: cover; /* Evita que la imagen se deforme */
  border-radius: 8px;
  transition: transform 0.3s ease;
  cursor: pointer;
}

/* Efecto visual al pasar el mouse */
.galleryItem:hover {
  transform: scale(1.03);
  box-shadow: 0px 4px 15px rgba(0,0,0,0.2);
}

.deleteGalleryItem {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}
</style>
